import React from 'react'
import { Form, InputGroup, Badge } from 'react-bootstrap'

export default ({ text, name, onChange, require, value, status, disabled, placeholder=name, required=false, ...props}) => {
  const className = required ? "text-grey font-weight-bold medium required" : "text-grey font-weight-bold medium";
  return (
    <>
      <Form.Group controlId={name}>
        <Form.Label className={className}>{text}</Form.Label>
        <InputGroup>
          <Form.Control 
            name={name} 
            disabled={disabled} 
            value={value} 
            onChange={({ target }) => onChange(target.name, target.value)} 
            placeholder={"Enter " + placeholder} 
            required={required} />
          <InputGroup.Append>
            <InputGroup.Text>
              {status === "Y"? 
              <Badge variant="success">ACTIVE</Badge>: 
              <Badge variant="secondary">INACTIVE</Badge>}
            </InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </Form.Group>
    </>
  )
}
